import '../styling/global.css';
import myGif from '../assets/aboutus.gif';
import img1 from '../assets/9.png';
import img2 from '../assets/10.png';
import img3 from '../assets/7.png';
import img4 from '../assets/8.png';
import img5 from '../assets/11.png';
import BackgroundEffect from '../components/BackgroundEffect';


const teamMembers = [
    {
        img: img1,
        name: 'Jangam Vazrakar',
        description: 'Founder',
    },
    {
        img: img2,
        name: ' Jangam Divya',
        description: 'Co Founder / HR Manager',
    },
    {
        img: img3,
        name: 'Jangam Madhukar',
        description: 'Head of AI Department',
    },
    {
        img: img5,
        name: 'Manchala S. Chakravarthy',
        description: 'Project Lead Manager',
    },
    {
        img: img4,
        name: 'Nakka Brahmanaidu',
        description: 'Branch Incharge',
    }
];

const AboutUs = () => {
    return (
        <div className="about-us">
            <BackgroundEffect />
            <section className="about-hero">
                <h1>About Us </h1>
            </section>

            <section className="about-content">
                <div className="about-text">
                    <h2>Our Story</h2>
                    <p>
                        With the passage of time, JSK Technologies has reached out to various kinds of customers dealing with transparency and practicality. Our continued
                        success of 13+ years is a remarkable effort which we promise to take further. We believe in our dream and consistently work to reach out to You. You are
                        valuable to us.
                    </p><br />
                    <p>
                        At JSK Technologies, it is an honor for everyone in our team to provide services to You. Let us show and make
                        You believe in our commitment to excellence and to your business holistically.
                    </p>
                </div>
                <div className='image-div'>
                    <img src={myGif} alt="My GIF" className='gif-image' />
                </div>
                <div className="about-values">
                    <h2>Our Motto</h2>
                    <p>
                        “We work with the motto of providing the depth of the research in time.” <br /><br />JSK Technologies is a leading company in Vijayawada, founded in November 2008.
                        The Founder/CEO Mr. Jangam Vazrakar began with the aim of reaching out to people through information services. While studying at NIT Jalandhar,
                        he envisioned providing web-based information to help organizations through outsourcing services. That seed grew into today’s leading company.
                    </p>
                </div>

                <div className="about-team">
                    <h2>Team Members</h2>
                    <div className="team-grid">
                        {teamMembers.map((member, i) => (
                            <div className="team-member" key={i}>
                                <img src={member.img} alt={`Team Member ${i + 1}`} />
                                <h3>{member.name}</h3>
                                <p>{member.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;
